import React from 'react';
import { LoaderSpinner as DefaultLoaderSpinner, LoaderSpinnerProps } from '../../shared/LoaderSpinner';

import commonStyles from './common-styles.module.scss';

export const LoaderSpinner: React.FC<LoaderSpinnerProps> = (props) => (
    <DefaultLoaderSpinner className={commonStyles.modalLayoutContainer} {...props} />
);
